import type { SummarizeFolderDrafts } from "./types";

// Mirrors the import: a plan already in the target folder stays, one in another folder moves only with overwrite.
export const summarizeFolderDrafts: SummarizeFolderDrafts = ({
  drafts,
  currentFolderNameByPlanId,
  overwrite,
}) => {
  const folderNameByKey = new Map(
    drafts.folders.map((folder) => [folder.key, folder.name.trim()]),
  );
  // By name: two folders renamed alike become one folder.
  const usedFolderNames = new Set<string>();
  const alreadyFiledFolderNameByPlanId = new Map<number, string>();
  let movedPlanCount = 0;

  for (const [floorPlanId, folderKey] of drafts.folderKeyByPlanId) {
    const folderName =
      folderKey === null ? undefined : folderNameByKey.get(folderKey);
    if (folderName === undefined) continue;
    usedFolderNames.add(folderName);

    const currentFolderName = currentFolderNameByPlanId.get(floorPlanId);
    if (currentFolderName === folderName) continue;
    if (currentFolderName !== undefined) {
      alreadyFiledFolderNameByPlanId.set(floorPlanId, currentFolderName);
    }
    if (currentFolderName === undefined || overwrite) movedPlanCount += 1;
  }

  return {
    folderCount: usedFolderNames.size,
    hasBlankFolderName: usedFolderNames.has(""),
    movedPlanCount,
    alreadyFiledFolderNameByPlanId,
  };
};
